import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import NcrsMasterService from '../../../../../services/vehicle-crash/masters/ncrs'

export const getNcrs = createAsyncThunk('ncrs/getNcrs', async (params, { rejectWithValue }) => {
  try {
    const response = await NcrsMasterService.getNcrs(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const addNcrs = createAsyncThunk('ncrs/addNcrs', async (ncr, { rejectWithValue, dispatch, getState }) => {
  try {
    await NcrsMasterService.addNcrs(ncr)
    dispatch(getNcrs(getState()?.ncr.params))
    return ncr
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateNcrs = createAsyncThunk('ncrs/updateNcrs', async (ncr, { rejectWithValue, dispatch, getState }) => {
  try {
    await NcrsMasterService.updateNcrs(ncr)
    dispatch(getNcrs(getState()?.ncr.params))
    return ncr
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteNcrs = createAsyncThunk('ncrs/deleteNcrs', async (id, { dispatch, getState }) => {
  await NcrsMasterService.deleteNcrs(id)
  await dispatch(getNcrs(getState()?.ncr.params))
  return id
})

const ncrSlice = createSlice({
  name: 'ncr',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},

  extraReducers(builder) {
    builder.addCase(getNcrs.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.params = action.payload.params
      state.total = action.payload.totalPages
    })
  }
})

export const selectNcrsById = (state, id) => state.ncr.data.find((ncr) => ncr.id === id)

export default ncrSlice.reducer
